import { PageHeader } from "@ant-design/pro-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Loader = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
`;

export const MainPageHeader = styled(PageHeader)`
  background: #db011c;
  padding: 2px;

  .ant-page-header-heading-title {
    color: white;
    font-size: 14px;
  }

  .ant-page-header-back-button {
    color: white;
  }

  .ant-page-header-back {
    margin-right: 8px;
  }

  .ant-page-header-heading-left {
    margin: 4px 12px;
  }
`;

export const ViperLogoWrapper = styled(Row)`
  height: 100%;
  padding: 0;
  align-content: center;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 84px;
  height: 100%;
  min-height: 100%;
  animation: ${fadeIn} 300ms ease-in-out;
  transition: transform 0.3s;
  background: #f1f4f6; //url('https://www.toptal.com/designers/subtlepatterns/patterns/white_wall_hash.png');
  flex: 1 0 auto;

  * {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

export const InnerContent = styled.div`
  flex: 1 0 auto;
`;

export const LogoWrapper = styled.div`
  padding-left: 8px;
  width: 100px;
  height: 100%;
  float: left;
  display: flex;
  cursor: pointer;

  img,
  svg {
    align-self: center;
  }
`;

export const NavbarContentWrapper = styled(Row)`
  height: 100%;
  padding: 0;
`;

export const StyledNavbarCol = styled(Col)`
  height: 50px;
`;

export const HamburgerIcon = styled(FontAwesomeIcon)`
  display: inline;
  color: #fff;
  font-size: x-large;
  padding: 8px;
  align-self: center;
`;

export const FooterLinks = styled.a`
  color: #fff;
  text-decoration: underline;
`;
